export const footerItems = [
  {
    id: 1,
    label: "About Us",
    url: "/",
    items: [
      { id: 5, label: "Our Story", url: "/about-us/" },
      { id: 6, label: "Traveller Reviews", url: "/testimonials/" },
      {
        id: 7,
        label: "Google Reviews",
        url: "https://www.google.com/search?q=10Adventures",
      },
      { id: 8, label: "Podcast", url: "/podcast/" },
      { id: 9, label: "Careers", url: "/join-our-team/" },
    ],
  },
  {
    id: 2,
    label: "Travellers",
    url: "/",
    items: [
      { id: 9, label: "Accommodation Policy", url: "/accommodation-policy/" },
      {
        id: 10,
        label: "Booking T&C",
        url: "/booking-terms-and-conditions-2024/",
      },
      { id: 11, label: "Safety", url: "/safety/" },
      {
        id: 12,
        label: "Tour Difficulty Ratings",
        url: "/tour-difficulty-assessment/",
      },
      { id: 13, label: "Trip Types", url: "/trip-types/" },
      { id: 14, label: "Travel Insurance", url: "/travel-insurance/" },
    ],
  },
  {
    id: 3,
    label: "Partners",
    url: "/",
    items: [
      { id: 15, label: "Affiliates", url: "/affiliate-program/" },
      { id: 17, label: "Ambassadors", url: "/brand-ambassador/" },
      { id: 18, label: "Suppliers", url: "/supplier-application/" },
    ],
  },
  {
    id: 4,
    label: "Support",
    url: "/",
    items: [
      { id: 16, label: "Contact Us", url: "/contact/" },
      { id: 17, label: "Currency", url: "/contact/" },
    ],
  },
]
